(() => {
  if (customElements.get('magdor-product-details')) return;
  const fields = [
    ['metal', /^(metal|métal|material|matériau|matière)$/i, 'Metal', 'Métal'],
    ['stone', /^(stone|stones|center stone|centre stone|pierre|pierres|pierre centrale|diamond type|type de diamant|diamond|diamant)$/i, 'Stone', 'Pierre'],
    ['centre', /^(center carat weight|centre stone weight|poids (en carats )?de la pierre centrale)$/i, 'Centre stone weight', 'Poids de la pierre centrale'],
    ['carat', /^(total (diamond |carat )?weight|diamond weight|carat weight|tdw|poids (total( des diamants| du diamant| en carats)?|en carats|du diamant))$/i, 'Carat weight', 'Poids en carats'],
    ['clarity', /^(diamond clarity|clarity|pureté( du diamant)?|clarté( du diamant)?)$/i, 'Clarity', 'Pureté'],
    ['colour', /^(diamond colou?r|colou?r|couleur( du diamant)?)$/i, 'Colour', 'Couleur'],
    ['cut', /^(cuts?|diamond cut|taille du diamant|tailles)$/i, 'Cut', 'Taille'],
    ['shape', /^(shape|forme)$/i, 'Shape', 'Forme'],
    ['setting', /^(setting( style)?|sertissage|serti|monture|style de sertissage)$/i, 'Setting', 'Sertissage'],
    ['band', /^(band|anneau)$/i, 'Band', 'Anneau'],
    ['length', /^(chain length|necklace length|length|longueur( de (la )?chaîne)?)$/i, 'Length', 'Longueur'],
    ['width', /^(band width|width|largeur( de la (chaîne|bande))?)$/i, 'Width', 'Largeur'],
    ['dimensions', /^(dimensions|measurements|center stone size|taille de la pierre centrale)$/i, 'Measurements', 'Dimensions'],
    ['size', /^(ring size|taille de (la )?bague|taille)$/i, 'Size', 'Taille'],
    ['style', /^style$/i, 'Style', 'Style'],
    ['design', /^(design|design aesthetic|esthétique du design)$/i, 'Design', 'Design'],
    ['finish', /^(finish|finition)$/i, 'Finish', 'Finition'],
    ['tone', /^(tone|ton)$/i, 'Tone', 'Ton'],
    ['closure', /^(closure|clasp|fermeture|fermoir)$/i, 'Closure', 'Fermoir'],
    ['chain', /^(chain type|type de chaîne)$/i, 'Chain type', 'Type de chaîne'],
    ['accent', /^(accent stones|pierres d.accent)$/i, 'Accent stones', 'Pierres d’accent'],
    ['karat', /^(gold karats|carats d.or)$/i, 'Gold purity', 'Titre de l’or'],
    ['custom', /^(customization|personnalisation)$/i, 'Personalization', 'Personnalisation'],
    ['crystal', /^(durable mineral crystal|verre minéral durable|crystal|verre)$/i, 'Crystal', 'Verre'],
    ['brand', /^(brand|marque)$/i, 'Brand', 'Marque'],
    ['movement', /^(watch mechanism|movement|mécanisme de la montre|mouvement)$/i, 'Movement', 'Mouvement'],
    ['case', /^(case size|approx\. case diameter|taille du boîtier|diamètre approximatif du boîtier)$/i, 'Case size', 'Taille du boîtier'],
    ['dial', /^(dial colou?r|dial|couleur du cadran|cadran)$/i, 'Dial', 'Cadran'],
    ['strap', /^(strap material|matière du bracelet|matériau du bracelet)$/i, 'Strap material', 'Matière du bracelet'],
    ['water', /^(water resistance|étanchéité|résistance à l[’']eau)( \(.*\))?$/i, 'Water resistance', 'Étanchéité']
  ];
  const clean = value => value.replace(/\s+/g, ' ').trim();
  const metalCase = value => value.replace(/\bwhite gold\b/gi, 'White Gold').replace(/\byellow gold\b/gi, 'Yellow Gold').replace(/\brose gold\b/gi, 'Rose Gold').replace(/\bsterling silver\b/gi, 'Sterling Silver').replace(/\bgold vermeil\b/gi, 'Gold Vermeil').replace(/\bor blanc\b/gi, 'Or Blanc').replace(/\bor jaune\b/gi, 'Or Jaune').replace(/\bor rose\b/gi, 'Or Rose').replace(/\bargent sterling\b/gi, 'Argent Sterling').replace(/\bor bicolore\b/gi, 'Or Bicolore');
  const inches = (value, fr) => value.replace(/(\d+(?:[.,]\d+)?)\s*(cm|inches|inch|in\b|pouces|["″])/gi, (_, n, unit) => {
    const amount = Number(n.replace(',', '.')) / (unit.toLowerCase() === 'cm' ? 2.54 : 1);
    return String(Math.round(amount * 100) / 100).replace('.', fr ? ',' : '.') + (fr ? ' po' : ' in');
  });
  class ProductDetails extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.render();
        if (!this.querySelector('[data-mgp-platinum-detail]') && !this.hasAttribute('data-configuration-metal')) return;
        this.onMetalChange = () => {
          this.syncPlatinumDetail();
          this.syncConfigurationMetal();
        };
        this.metalRoot = this.closest('#mgp');
        this.metalRoot?.addEventListener('change', this.onMetalChange);
        this.syncPlatinumDetail();
        this.syncConfigurationMetal();
      });
    }
    disconnectedCallback() {
      if (this.onMetalChange) this.metalRoot?.removeEventListener('change', this.onMetalChange);
      this.metalRoot = null;
    }
    syncPlatinumDetail() {
      const detail = this.querySelector('[data-mgp-platinum-detail]');
      const root = this.closest('#mgp');
      if (!detail || !root) return;
      const selectedMetal = root.querySelector('.mgp-metal-options input[type="radio"]:checked')?.value
        || root.querySelector('#mgp-form .mgp-option[data-index="0"]')?.value;
      detail.hidden = selectedMetal !== 'Platinum';
    }
    syncConfigurationMetal() {
      if (!this.hasAttribute('data-configuration-metal')) return;
      const root = this.closest('#mgp');
      const selected = root?.querySelector('.mgp-metal-options input[type="radio"]:checked');
      const detail = [...this.querySelectorAll('.mgp-facts dt')].find(term => /^(metal|métal)$/i.test(term.textContent.trim()))?.nextElementSibling;
      if (!selected || !detail) return;
      if (!this.listedMetal) this.listedMetal = detail.textContent;
      const name = selected.closest('label')?.querySelector('.mgp-metal-name')?.textContent;
      const fr = this.dataset.language.startsWith('fr');
      detail.textContent = selected.value === 'listed' ? this.listedMetal : name + (fr ? ' — Sur demande' : ' — Upon request');
    }
    render() {
      const source = this.querySelector('[data-mgp-spec-source]');
      const list = this.querySelector('.mgp-facts');
      if (!source || !list) return;
      const fr = this.dataset.language.startsWith('fr');
      const doc = source.content;
      const rows = new Map();
      const extras = [];
      const add = (label, value, generic = false) => {
        label = clean(label); value = clean(value);
        if (!label || !value) return;
        const field = fields.find(f => f[1].test(label));
        if (!field && !generic) return;
        const key = field ? field[0] : label.toLowerCase();
        if (rows.has(key)) {
          const previous = rows.get(key);
          if (!previous.value.toLowerCase().includes(value.toLowerCase())) previous.value += ' · ' + value;
          return;
        }
        rows.set(key, {label: field ? field[fr ? 3 : 2] : label, value: key === 'length' ? inches(value, fr) : key === 'metal' || key === 'tone' ? metalCase(value).replace(/\b(solid|gold|silver|vermeil|massif|blanc|jaune|rose|bicolore)\b/gi, word => word[0].toUpperCase() + word.slice(1).toLowerCase()) : metalCase(value)});
      };
      const readLine = (text, generic, unlabelled) => {
        text = clean(text);
        if (!text) return;
        const at = text.indexOf(':');
        if (at > 0 && at < 65 && !(text.slice(0, at).length > 15 && text.slice(0, at) === text.slice(0, at).toUpperCase())) { add(text.slice(0, at), text.slice(at + 1), generic); return; }
        if (!unlabelled) return;
        if (/^(?:solid )?\d{1,2}k (?:solid |white |yellow |rose )?gold\b|^or (?:massif |blanc |jaune |rose )?\d{1,2}k\b|^(?:925 )?sterling silver\b|^argent (?:sterling|massif)\b|^stainless steel$|^acier inoxydable$/i.test(text)) add('Metal', text);
        else if (/\b(?:length|longueur)\b/i.test(text)) add('Length', text);
        else if (/\b(?:clasp|closure|fermoir|boucle déployante)\b/i.test(text)) add('Closure', text);
        else if (/\b(?:movement|mouvement)\b/i.test(text)) add('Movement', text);
        else if (/\b(?:dial|cadran)\b/i.test(text)) add('Dial', text);
        else if (/\b(?:case|boîtier)\b/i.test(text) && /\d\s*mm/i.test(text)) add('Case size', text);
        else if (/\b(?:finish|finition|fini|polished|poli)\b/i.test(text)) add('Finish', text);
        else if (/\b(?:design|unisexe?)\b/i.test(text)) add('Design', text);
        else if (/\b(?:chain|chaîne)\b/i.test(text)) add('Chain type', text);
        else extras.push(text);
      };
      doc.querySelectorAll('tr').forEach(tr => {
        const cells = [...tr.children].filter(e => /^(TD|TH)$/.test(e.tagName));
        if (cells.length >= 2) add(cells[0].textContent.replace(/:\s*$/, ''), cells.slice(1).map(e => e.textContent).join(' '), true);
      });
      doc.querySelectorAll('dt').forEach(dt => { if (dt.nextElementSibling?.tagName === 'DD') add(dt.textContent.replace(/:\s*$/, ''), dt.nextElementSibling.textContent, true); });
      doc.querySelectorAll('li').forEach(li => { if (!li.querySelector('li')) readLine(li.textContent, true, true); });
      doc.querySelectorAll('p').forEach(p => {
        if (p.closest('li,table,dl')) return;
        const clone = p.cloneNode(true); clone.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
        clone.textContent.split('\n').forEach(line => readLine(line, false, false));
      });
      const preserved = doc.querySelector('[data-magdor-title-specifications] li')?.textContent.replace(/^[^:]+:\s*/, '');
      const title = preserved || this.dataset.title || '';
      if (!rows.has('metal')) {
        const silver = /\b(?:sterling silver|argent (?:sterling|massif)|925)\b/i.test(title);
        const plated = /\b(?:plat(?:ed|ing)|plt|plaqué|doré)\b/i.test(title);
        const vermeil = /\bvermeil\b/i.test(title);
        if (silver && /silver|argent|vermeil/i.test(title)) {
          let metal = /925/.test(title) ? (fr ? 'Argent 925' : '925 Silver') : (fr ? 'Argent Sterling' : 'Sterling Silver');
          if (/sterling|massif/i.test(title)) metal = /925/.test(title) ? (fr ? 'Argent Sterling 925' : '925 Sterling Silver') : metal;
          if (vermeil) metal += fr ? ' — Vermeil' : ' — Gold Vermeil';
          else if (plated && /gold|\bor\b|doré/i.test(title)) metal += fr ? ' — Plaqué Or' : ' — Gold Plated';
          add('Metal', metal);
        } else if (/\bplatinum\b|\bplatine\b/i.test(title)) add('Metal', fr ? 'Platine' : 'Platinum');
        else if (/stainless steel|acier inoxydable/i.test(title)) add('Metal', fr ? 'Acier Inoxydable' : 'Stainless Steel');
        else {
          const karat = title.match(/\b(9|10|14|18|22|24)\s*k\b/i) || title.match(/\bor(?: (?:blanc|jaune|rose|massif))?\s+(9|10|14|18|22|24)\s*carats?\b/i);
          if (karat && /gold|\bor\b|\b[wyr]g\b/i.test(title)) {
            const tone = /\b(?:two[ -]?tone|2[ -]?tone|bicolore)\b/i.test(title) ? (fr ? 'Or Bicolore' : 'Two-Tone Gold') : /\b(?:white gold|w[ .-]+gold|wg|or blanc)\b/i.test(title) ? (fr ? 'Or Blanc' : 'White Gold') : /\b(?:yellow gold|y[ .-]+gold|yg|or jaune)\b/i.test(title) ? (fr ? 'Or Jaune' : 'Yellow Gold') : /\b(?:rose gold|pink gold|rg|or rose)\b/i.test(title) ? (fr ? 'Or Rose' : 'Rose Gold') : (fr ? 'Or' : 'Gold');
            add('Metal', (fr ? tone + ' ' + karat[1] + 'K' : karat[1] + 'K ' + tone) + (plated ? (fr ? ' — Plaqué' : ' — Plated') : ''));
          }
        }
      }
      if (!rows.has('stone')) {
        const stones = [];
        if (/\blab(?:oratory)?\b.*?\bdia(?:mond)?|diamants? (?:de laboratoire|de synthèse|synthétiques?)/i.test(title)) stones.push(fr ? 'Diamant de Laboratoire' : 'Lab-Grown Diamond');
        else if (/\b(?:diamond|dia|diamants?)\b/i.test(title) && !/\b(?:diamond|dia)[ -]cut\b|(?:taille|coupe) diamant|taill[ée]+s? au diamant|diamanté/i.test(title)) stones.push(fr ? 'Diamant' : 'Diamond');
        if (/moissanite/i.test(title)) stones.push('Moissanite');
        if (/cubic zirconia|zircon(?:s|e|es)? cubiques?|oxydes? de zirconium|\bcz\b/i.test(title)) stones.push(fr ? 'Zircone Cubique' : 'Cubic Zirconia');
        if (/mother[ -]of[ -]pearl|nacre/i.test(title)) stones.push(fr ? 'Nacre' : 'Mother of Pearl');
        for (const [pattern, en, french] of [[/\bpearls?\b|\bperles?\b/i, 'Pearl', 'Perle'], [/\bruby\b|\brubis\b/i, 'Ruby', 'Rubis'], [/\bsapphire\b|\bsaphir\b/i, 'Sapphire', 'Saphir'], [/\bemerald\b|\bémeraude\b/i, 'Emerald', 'Émeraude'], [/\btopaz\b|\btopaze\b/i, 'Topaz', 'Topaze'], [/\bamethyst\b|\baméthyste\b/i, 'Amethyst', 'Améthyste']]) {
          if (pattern.test(title) && !(en === 'Pearl' && /mother[ -]of[ -]pearl|nacre/i.test(title)) && !/\bcz\b|zircon|oxyde/i.test(title) && !/emerald[ -]cut|taille émeraude/i.test(title)) stones.push(fr ? french : en);
        }
        if (stones.length) add('Stone', stones.join(' · '));
      }
      if (!rows.has('carat') && !rows.has('centre')) {
        const weightTitle = title.replace(/\bor(?: (?:blanc|jaune|rose|massif))?\s+(?:9|10|14|18|22|24)\s*carats?\b/gi, '').replace(/\b(?:9|10|14|18|22|24)\s*carats?\s+(?:en )?or\b/gi, '');
        const weights = [...weightTitle.matchAll(/(?<![\d.,])(\d+(?:[.,]\d+)?)\s*(cttw|ctw|cts?|carats?)\b/gi)].filter(m => !(fr && /^carat/i.test(m[2]) && /^(9|10|14|18|22|24)$/.test(m[1])));
        if (weights.length === 1 && !/center|centre|centrale/i.test(weightTitle)) add('Carat Weight', weights[0][1].replace('.', fr ? ',' : '.') + ' ' + (/cttw|ctw/i.test(weights[0][2]) ? 'cttw' : 'ct'));
      }
      if (extras.length) add(fr ? 'Détails' : 'Details', [...new Set(extras)].join(' · '), true);
      list.replaceChildren();
      const order = fields.map(f => f[0]);
      const sorted = [...rows].sort(([a], [b]) => (order.includes(a) ? order.indexOf(a) : 99) - (order.includes(b) ? order.indexOf(b) : 99));
      if (!sorted.length) sorted.push(['details', {label:fr ? 'Détails' : 'Details', value:fr ? 'Contactez-nous pour les spécifications de cette pièce.' : 'Contact us for this piece’s specifications.'}]);
      for (const [, row] of sorted) {
        const dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = row.label === (fr ? 'Pierre' : 'Stone') && /pearl|perle/i.test(row.value) ? (fr ? 'Gemme' : 'Gem') : row.label; dd.textContent = row.value; list.append(dt, dd);
      }
      const timing = [...doc.querySelectorAll('p,li')].find(e => /lead time|délai/i.test(e.textContent) && /week|semaine|day|jour/i.test(e.textContent));
      const leadTime = this.closest('#mgp')?.querySelector('#mgp-lead-time');
      if (timing && leadTime) leadTime.textContent = clean(timing.textContent);
      this.dataset.ready = 'true';
    }
  }
  customElements.define('magdor-product-details', ProductDetails);
})();
